import { v4 as uuidv4 } from 'uuid';
import { stepPersonalAccidentSCTILookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses(data) {
  const personalAccidentExpenses = mapToPersonalAccident(data);
  return [...personalAccidentExpenses];
}

function getGroupId(item) {
  const selectedClaimForArray = item.selectedClaimFor
    ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor
    : [];
  return selectedClaimForArray.length > 1 ? uuidv4() : null;
}

function mapToPersonalAccident(data) {
  let claimCode = expenseLookup.isThisClaimRelatedToPersonalAccident.claimCode;
  const expenses = [];
  if (data.isThisClaimRelatedToPersonalAccident === 'true' && data.infoClaimRelatedToPersonalAccidentItems.length > 0) {
    data.infoClaimRelatedToPersonalAccidentItems.forEach(
      (item) => {
        const groupId = getGroupId(item);
        const expense = mapExpenseItem(item, data, claimCode, groupId);
        if (!!expense) {
          expenses.push(expense);
        }
        const reimburseExpense = mapReimbursement(item, data, claimCode, getGroupId(item));
        if (!!reimburseExpense) {
          expenses.push(reimburseExpense);
        }
      }
    );
  }

  if (data.isThisClaimRelatedToLossOfLifeCausedByAnInjury === 'true' && data.infoClaimRelatedToLossOfLifeItems.length > 0) {
    claimCode = expenseLookup.isThisClaimRelatedToLossOfLifeCausedByAnInjury.claimCode;
    data.infoClaimRelatedToLossOfLifeItems.forEach(
      (item) => {
        const groupId = getGroupId(item);
        const expense = mapExpenseItem(item, data, claimCode, groupId);
        if (!!expense) {
          expenses.push(expense);
        }
        const reimburseExpense = mapReimbursement(item, data, claimCode, getGroupId(item));
        if (!!reimburseExpense) {
          expenses.push(reimburseExpense);
        }
      }
    );
  }

  if (data.didTheInjuryLeaveYouPermanentlyDisabled === 'true' && data.infoDidTheInjuryLeaveYouPermanentlyDisabledItems.length > 0) {
    claimCode = expenseLookup.didTheInjuryLeaveYouPermanentlyDisabled.claimCode;
    data.infoDidTheInjuryLeaveYouPermanentlyDisabledItems.forEach(
      (item) => {
        const groupId = getGroupId(item);
        const expense = mapExpenseItem(item, data, claimCode, groupId);
        if (!!expense) {
          expenses.push(expense);
        }
        const reimburseExpense = mapReimbursement(item, data, claimCode, getGroupId(item));
        if (!!reimburseExpense) {
          expenses.push(reimburseExpense);
        }
      }
    );
  }

  if (data.didTheInjuryResultInYourInabilityToReturnToWork === 'true' && data.infoYourInabilityToReturnToWorkItems.length > 0) {
    claimCode = expenseLookup.didTheInjuryResultInYourInabilityToReturnToWork.claimCode;
    data.infoYourInabilityToReturnToWorkItems.forEach(
      (item) => {
        const groupId = getGroupId(item);
        const expense = mapExpenseItem(item, data, claimCode, groupId);
        if (!!expense) {
          expenses.push(expense);
        }
        const reimburseExpense = mapReimbursement(item, data, claimCode, getGroupId(item));
        if (!!reimburseExpense) {
          expenses.push(reimburseExpense);
        }
      }
    );
  }

  return expenses;
}

function mapExpenseItem(item, itemDate, claimCode, groupId) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountClaimed || !item.currency) {
    return null;
  }
  return {
    shortDescription: `${item.descriptionOfItem}`,
    dateOfExpense: item.dateOfExpenses,
    clientCost: item.amountClaimed,
    currency: item.currency,
    rate: null,
    requestedAmount: null,
    assessorValue: item.amountClaimed,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
    groupId,
  };
}

function mapReimbursement(item, formData, claimCode, groupId) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountCreditedOrRefunded || !item.currencyCreditedOrRefunded || item.haveYouReceivedAnyCreditOrRefundFromTheServiceProvider !== 'true') {
    return null;
  }
  return {
    shortDescription: `${item.descriptionOfItem} (Reimbursement)`,
    dateOfExpense: item.dateOfExpenses,
    clientCost: `${item.amountCreditedOrRefunded * -1}`,
    currency: item.currencyCreditedOrRefunded,
    rate: null,
    requestedAmount: null,
    assessorValue: `${item.amountCreditedOrRefunded * -1}`,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
    groupId,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepPersonalAccidentSCTIDataMapper.js